// removed by extract-text-webpack-plugin
module.exports = {"root":"root__Jgsrz","extra":"extra__2cepb","wrapper":"wrapper__yhMKT","isVisible":"isVisible__3G6fI","override":"override__q31Br","next":"next__IP-O9"};


//////////////////
// WEBPACK FOOTER
// ./components/RomanceBreakdownViz/Section/style.css
// module id = 9rP9
// module chunks = 0